module.exports = __webpack_public_path__ + "img/img11.0c9fa52c.png";